<template>
    <div class="gray-back" style="padding:.2rem 0 6rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-divider>开始建设</van-divider>
            <van-cell-group>

                <van-cell title="一星舞蹈" value="" is-link @click="jianshe('一星','舞蹈')" />
                <van-cell title="一星技巧" value="" is-link @click="jianshe('一星','技巧')" />
                <van-cell title="二星舞蹈" value="" is-link @click="jianshe('二星','舞蹈')" />
                <van-cell title="二星技巧" value="" is-link @click="jianshe('二星','技巧')" />
                <van-cell title="三星舞蹈" value="" is-link @click="jianshe('三星','舞蹈')" />
                <van-cell title="三星技巧" value="" is-link @click="jianshe('三星','技巧')" />
                <van-cell title="四星舞蹈" value="" is-link @click="jianshe('四星','舞蹈')" />
                <van-cell title="四星技巧" value="" is-link @click="jianshe('四星','技巧')" />
                <van-cell title="五星舞蹈" value="" is-link @click="jianshe('五星','舞蹈')" />
                <van-cell title="五星技巧" value="" is-link @click="jianshe('五星','技巧')" />

            </van-cell-group>


        </van-form>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }



    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
        .use(Switch).use(Button);
    export default {
        name: 'ClubApply',
        components: {
            PicUploader,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                formData: {
                    id: 0,
                },
            }
        },
        filters: {},
        mounted() {
            document.title="开始建设"
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
//            if(that.formData.id){
            this.fetch();
//            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            jianshe(grade,gradetype){
                let that= this;

                that.saveLoading = true;

                that.$api.post('/api/club/jiansheStep1Save', {
                    grade:grade ,
                    gradetype:gradetype
                }, (res) => {
                    that.saveLoading = false;

                    rbLink({
                        name:"ClubJiansheStep2",
                        query:{
                            id:res.data.id
                        }
                    },'replace')

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/club/jiansheStep1Detail', {
                }, (res) => {
                    that.formData = res.data;
                }, (res) => {
//                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// ClubJiansheStep1.vue?eeed1922